/**
 * Processes a subscription array and checks for an active subscription
 * @param {Array} subscriptions
 */
export const processSubscriptionsObj = (subscriptions) => {
  return checkForActiveSubscriptions(sanitizeSubscriptionsObj(subscriptions));
};

/**
 * Ensures that subscriptions gets sanitized as an array even if a falsy or undefined value is passed in
 * @param {Array} subscriptions
 */
export const sanitizeSubscriptionsObj = (subscriptions) => {
  if (!Array.isArray(subscriptions)) {
    return [];
  }
  return subscriptions;
};

/**
 * Looks for active subscriptions in a subscriptions array.
 *  * @param {Array} subscriptions
 */
export const checkForActiveSubscriptions = (subscriptions) => {
  let retVal = false;
  const now = new Date();
  subscriptions.forEach(subscription => {
    if (isSubscriptionActive(now, subscription)) {
      retVal = true;
    }
  });
  return retVal;
};

/**
 * Determines if a subscription is active
 *  * @param {Date} now
 *  * @param {Object} subscription
 */
export const isSubscriptionActive = (now, subscription) => {
  const { isActive, earliestExpirationDate } = subscription;
  return isValidISOTime(earliestExpirationDate) && isActive && !isSubscriptionExpired(now, new Date(earliestExpirationDate));
};

/**
 * Ensures that the iso time is a string
 * @param {string} isoTime
 */
export const isValidISOTime = (isoTime) => {
  if (typeof isoTime !== 'string') return false;
  const time = new Date(isoTime);
  const timestamp = time.getTime();
  return !isNaN(timestamp);
};

/**
 * It is only expired if the expy timestamp is less than the timestamp
 * @param {Date} currTimestamp
 * @param {Date} expTimestamp
 */
export const isSubscriptionExpired = (currTimestamp, expTimestamp) => {
  return expTimestamp.getTime() < currTimestamp.getTime();
};
